import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-ab-date-time',
  templateUrl: './ab-date-time.component.html',
  styleUrls: ['./ab-date-time.component.scss']
})
export class AbDateTimeComponent implements OnInit {

 @Input() element: any;
  constructor() { }

  ngOnInit(): void {
  }

}
